import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../../environments/environment';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';

@Injectable()
export class TipoEventoService extends ServiceBase {
  private baseUrlService: string;

  constructor(
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cruzamento_tipo_evento`;
  }

  /**
   * Busca todos os tipos de evento
   */
  public getTipoEventos(): Promise<any> {
    return this.get([]);
  }

  /**
   * Adiciona um novo tipo de evento
   */
  public adicionarTipoEvento(nome: string): Promise<any> {
    const url = this.getURL();
    const body = {
      descEventoFab: nome
    };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  /**
   * Remove um tipo de evento
   */
  public removerTipoEvento(id: number): Promise<any> {
    const url = `${this.getURL()}?idTipoEvento=${id}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.delete(url, options)
      .toPromise()
      .then((this as any).tratarRetorno);
  }

  /**
   * Atualiza um tipo de evento existente
   */
  public atualizarTipoEvento(id: number, nome: string): Promise<any> {
    const parametros = [
      { nome: 'idTipoEvento', valor: id.toString() }
    ];
    const body = {
      descEventoFab: nome
    };
    return this.atualizar(body, parametros);
  }

  /**
   * Busca um tipo de evento específico por ID
   */
  public getTipoEventoPorId(id: number): Promise<any> {
    const parametros = [
      { nome: 'idTipoEvento', valor: id.toString() }
    ];
    return this.get(parametros);
  }

  /**
   * Busca os vínculos de um tipo de evento específico
   */
  public getVinculosTipoEvento(idTipoEvento: number): Promise<any> {
    const url = `${this.getURL()}/vinculos?idTipoEvento=${idTipoEvento}`;
    const options = (this as any).getOptions();
    
    return (this as any).http.get(url, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro na requisição de vínculos:', error);
        throw error;
      });
  }

  /**
   * Salva os vínculos de um tipo de evento
   */
  public salvarVinculosTipoEvento(idTipoEvento: number, elementosVinculados: any[]): Promise<any> {
    const url = `${this.getURL()}/vincular?idTipoEvento=${idTipoEvento}`;
    const body = {
      descTipoEventos: elementosVinculados.map(elemento => ({
        descTipoEvento: elemento.nome,
        contemFabrica: !!elemento.contemFabrica
      }))
    };
    const options = (this as any).getOptions();
    
    return (this as any).http.post(url, body, options)
      .toPromise()
      .then((response: any) => {
        return (this as any).tratarRetorno(response);
      })
      .catch((error: any) => {
        console.error('Erro ao salvar vínculos:', error);
        throw error;
      });
  }
}
